// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1rDrv","title":"Info_title__36z_9","links":"Info_links__1YsNr","link":"Info_link__1HAO8","logo":"Info_logo__3MSIB"};